/** Get Dashboard saas Top selling data */

export const API_SUCCESS = "API_SUCCESS";
export const API_FAIL = "API_FAIL";
export const GET_TOP_SELLING_PRODUCT = "GET_TOP_SELLING_PRODUCT";
export const GET_EARNING_DATA = "GET_EARNING_DATA";
export const GET_REPORTED_MESSAGES = "GET_REPORTED_MESSAGES"
export const GET_REPORTED_MESSAGES_SUCCESS = "GET_REPORTED_MESSAGES_SUCCESS"
export const GET_REPORTED_MESSAGES_FAIL = "GET_REPORTED_MESSAGES_FAIL"
export const CHANGE_REPORTED_MESSAGE_STATUS = "CHANGE_REPORTED_MESSAGE_STATUS"
export const CHANGE_REPORTED_MESSAGE_STATUS_SUCCESS = "CHANGE_REPORTED_MESSAGE_STATUS_SUCCESS"
export const CHANGE_REPORTED_MESSAGE_STATUS_FAIL = "CHANGE_REPORTED_MESSAGE_STATUS_FAIL"